// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `@media screen and (min-width:950px){
    .inactive-devices-report-container{
        box-shadow: 0 0 5px rgba(0, 0, 0, 0.5);
        background-color: white;
        position: absolute;
        top: 2vh;
        right: 0px;
        height: 95%;
        width: 0%;
        box-sizing: border-box;
        border-radius: 10px 0px 0px 10px;
        animation: inactive-devices-report-container-stretch-in 0.45s ease-out forwards;
    }
    @keyframes inactive-devices-report-container-stretch-in {
        from {
            width: 0;
        }
        to{
            width: 70%;
        }
    }
    .inactive-devices-report-header{
        color: white;
        background-color: rgba(155, 30, 30, 0.952);
        padding: 15px;
        border-radius: 10px 0px 0px 0px;
        display: flex;
        justify-content: space-between;
    }
    .inactive-devices-report-header h3{
        margin: 0px;
        font-weight: lighter;
    }
    .inactive-devices-report-header h4{
        margin: 0px;
        font-weight: lighter;
        font-size: 14px;
    }
    .inactive-devices-report-header p{
        margin: 0px;
        margin-right: 20px;
        font-weight: lighter;
        font-size: 30px;
        cursor: pointer;
    }
    .inactive-devices-report-navigation-bar{
        display: flex;
        padding: 4px 3px;
        justify-content: space-between;
        border-bottom: 1px solid rgb(179, 179, 179);
    }
    .inactive-devices-report-schedule-button-container,
    .inactive-devices-report-devices-button-container,
    .inactive-devices-report-recipients-button-container{
        display: inline-block;
        padding: 12px 10px;
    }
    .inactive-devices-report-tab-navigation-bar button{
        border: none;
        outline: none;
        margin: 0px;
        border-radius: 80px;
        padding: 8px 15px;
        cursor: pointer;
        box-shadow: 0px 0px 2px rgba(0, 0, 0, 0.5);
        background-color: transparent;
        transition: background-color 0.3s ease;
    }
    .inactive-devices-report-edit-controls{
        padding: 10px 2vw;
        align-items: center;
    }
    .inactive-devices-report-edit-controls button{
        border: none;
        color: white;
        cursor: pointer;
        margin: 0px 10px;
        border-radius: 50%;
        background-color: rgba(233, 77, 30, 0.963);
    }
    .inactive-devices-report-edit-controls img{
        height: 17px;
    }
    .inactive-devices-report-save-changes-button,.inactive-devices-report-discard-changes-button{
        padding: 12px 16px;
    }
    .inactive-devices-report-edit-button{
        margin: 0px;
        padding: 10px 12px;
    }
    /*Details tab*/
    .inactive-devices-report-details-tab-container{
        display: flex;
        margin: 10px;
        padding: 8vh 30px;
        border-radius: 10px;
        align-content: center;
        justify-content: left;
        box-shadow: 0px 0px 1px rgba(0, 0, 0, 0.5);
    }
    .inactive-devices-report-details-tab-container p{
        margin: 0px;
        margin-top: 8px;
        margin-right: 40px;
    }
    .inactive-devices-report-details-tab-container input{
        width: 25%;
        margin: 0px;
        border: none;
        outline: none;
        padding: 10px 20px;
        border-radius: 20px;
        box-shadow: 0px 0px 4px rgba(0, 0, 0, 0.5);
    }
    /*Devices tab*/
    .inactive-devices-report-devices-controls-container{
        display: flex;
        padding: 20px 30px;
        justify-content: space-between;
    }
    .inactive-devices-report-devices-controls-container p{
        margin: 0px;
    }
    .inactive-devices-report-devices-controls-container button{
        border: none;
        color: white;
        cursor: pointer;
        padding: 5px 14px;
        border-radius: 4px;
        box-shadow: 2px 2px 4px rgba(0, 0, 0, 0.5);
        background-color: rgba(155, 30, 30, 0.952);
    }
    .inactive-devices-report-devices-empty-table-container{
        width: 30vw;
        margin-top: 5vh;
        margin-left: 14vw;
        padding: 10px 20px;
        border-radius: 10px;
        box-shadow: 0px 0px 5px rgba(0, 0, 0, 0.5);
    }
    .inactive-devices-report-devices-empty-table-container h4{
        margin: 0px;
        font-size: 18px;
        text-align: center;
        font-weight: lighter;
    }
    .inactive-devices-report-devices-empty-table-container p{
        margin: 6px 0px;
    }
    .inactive-devices-report-devices-table-container{
        height: 30vh;
        margin: 5px 30px;
        padding: 2px 5px;
        overflow-y: auto;
    }
    .inactive-devices-report-devices-table-container table{
        width: 100%;
        margin: 0px;
        padding: 0px;
        font-size: 16px;
        text-align: left;
        table-layout: fixed;
        box-sizing: border-box;
        border-collapse: collapse;
        box-shadow: 0px 0px 2px rgba(0, 0, 0, 0.5);
    }
    .inactive-devices-report-devices-table-container table tr:nth-child(odd){
        background-color: rgba(206, 206, 206,0.953);
    }
    #inactive-devices-report-devices-table-header-row{
        background-color: transparent;
    }
    .inactive-devices-report-devices-table-container table td,
    .inactive-devices-report-devices-table-container table th{
        padding: 4px 0px;
    }
    .inactive-devices-report-devices-table-container table img{
        height: 20px;
        cursor: pointer;
    }
    .inactive-devices-report-devices-browser-container{
        position: absolute;
        background-color: white;
        box-shadow: 0px 0px 2px rgba(0, 0, 0, 0.5);
        height: 18vh;
        width: 24vw;
        top: 28vh;
        left: 36vh;
        border-radius: 10px;
    }
    .inactive-devices-report-devices-browser-header{
        display: flex;
        color: white;
        padding: 10px 15px;
        justify-content: space-between;
        border-radius: 10px 10px 0px 0px;
        background-color: rgba(155, 30, 30, 0.952);
    }
    .inactive-devices-report-devices-browser-header h3{
        margin: 0px;
    }
    .inactive-devices-report-devices-browser-header p{
        margin: 0px;
        cursor: pointer;
    }
    .inactive-devices-report-devices-browser-body{
        display: flex;
        justify-content: center;
    }
    .inactive-devices-report-devices-browser-body select{
        width: 80%;
        padding: 8px;
        background-color: transparent;
        box-shadow: 0px 0px 2px rgba(0, 0, 0, 0.5);
    }
    .inactive-devices-report-devices-browser-add-button-container{
        text-align: right;
        padding: 25px 10%;
    }
    .inactive-devices-report-devices-browser-add-button-container button{
        border: none;
        color: white;
        cursor: pointer;
        padding: 8px 20px;
        border-radius: 6px;
        background-color: rgba(155, 30, 30, 0.952);
        box-shadow: 2px 2px 2px rgba(0, 0, 0, 0.5);
    }
    /*Schedule tab*/
    .inactive-devices-report-schedule-controls-container{
        display: flex;
        padding: 20px 30px;
        justify-content: space-between;
    }
    .inactive-devices-report-schedule-controls-container p{
        margin: 0px;
    }
    .inactive-devices-report-schedule-controls-container button{
        border: none;
        color: white;
        cursor: pointer;
        padding: 5px 14px;
        border-radius: 4px;
        box-shadow: 2px 2px 4px rgba(0, 0, 0, 0.5);
        background-color: rgba(155, 30, 30, 0.952);
    }
    .inactive-devices-report-schedule-entries-empty-table-container{
        width: 30vw;
        margin-top: 5vh;
        margin-left: 14vw;
        padding: 10px 20px;
        border-radius: 10px;
        box-shadow: 0px 0px 5px rgba(0, 0, 0, 0.5);
    }
    .inactive-devices-report-schedule-entries-empty-table-container h4{
        margin: 0px;
        font-size: 18px;
        text-align: center;
        font-weight: lighter;
    }
    .inactive-devices-report-schedule-entries-empty-table-container p{
        margin: 6px 0px;
    }
    .inactive-devices-report-schedule-entries-table-container{
        height: 30vh;
        margin: 5px 30px;
        padding: 2px 5px;
        overflow-y: auto;
    }
    .inactive-devices-report-schedule-entries-table-container table{
        width: 100%;
        margin: 0px;
        padding: 0px;
        font-size: 16px;
        text-align: left;
        table-layout: fixed;
        box-sizing: border-box;
        border-collapse: collapse;
        box-shadow: 0px 0px 2px rgba(0, 0, 0, 0.5);
    }
    #inactive-devices-report-schedule-entries-table-header-row{
        background-color: transparent;
    }
    .inactive-devices-report-schedule-entries-table-container table tr:nth-child(odd){
        background-color: rgba(206, 206, 206,0.953);
    }
    .inactive-devices-report-schedule-entries-table-container table th,
    .inactive-devices-report-schedule-entries-table-container table td{
        padding: 4px 6px;
    }
    .inactive-devices-report-schedule-entries-table-container table th{
        font-weight: 700;
    }
    .inactive-devices-report-schedule-entries-table-container table td{
        font-weight: 500;
    }
    .inactive-devices-report-schedule-entries-table-container table img{
        height: 20px;
        cursor: pointer;
        padding: 4px 20px;
    }
    .inactive-devices-report-schedule-entries-table-container table div{
        display: flex;
        justify-content: center;
    }
    .report-schedule-entry-container{
        position: absolute;
        background-color: white;
        box-shadow: 0px 0px 2px rgba(0, 0, 0, 0.5);
        height: 32vh;
        width: 34vw;
        top: 22vh;
        left: 27vh;
        border-radius: 10px;
    }
    .report-schedule-entry-header{
        display: flex;
        color: white;
        padding: 10px 15px;
        justify-content: space-between;
        border-radius: 10px 10px 0px 0px;
        background-color: rgba(155, 30, 30, 0.952);
    }
    .report-schedule-entry-header h4{
        margin: 0px;
        font-weight: lighter;
    }
    .report-schedule-entry-header p{
        margin: 0px;
        cursor: pointer;
    }
    .report-schedule-frequency-entry-container{
        display: grid;
        padding: 20px 60px;
        padding-bottom: 10px;
        align-content: center;
        grid-template-columns: 2fr 3fr;
    }
    .report-schedule-frequency-entry-container p{
        margin: 6px 0px;
    }
    .report-schedule-frequency-entry-container select{
        width: 60%;
        margin: 0px;
        padding: 6px;
        background-color: transparent;
        box-shadow: 0px 0px 2px rgba(0, 0, 0, 0.5);
    }
    .report-schedule-time-entry-container{
        display: grid;
        padding: 10px 60px;
        align-content: center;
        grid-template-columns: 2fr 3fr;
    }
    .report-schedule-time-entry-container input{
        width: 54%;
        margin: 0px;
        height: 30px;
        border: none;
        outline: none;
        margin: 12px 0px;
        padding: 0px 10px;
        border-radius: 4px;
        background-color: transparent;
        box-shadow: 0px 0px 2px rgba(0, 0, 0, 0.5);
    }
    .report-schedule-inactivity-threshold-entry-container{
        display: grid;
        padding: 20px 60px;
        padding-bottom: 10px;
        align-content: center;
        grid-template-columns: 2fr 3fr;
    }
    .report-schedule-inactivity-threshold-entry-container p{
        margin: 6px 0px;
    }
    .report-schedule-inactivity-threshold-entry-container select{
        width: 60%;
        margin: 0px;
        padding: 6px;
        background-color: transparent;
        box-shadow: 0px 0px 2px rgba(0, 0, 0, 0.5);
    }
    .report-schedule-add-button-container{
        text-align: right;
        padding: 0px 30px;
    }
    .report-schedule-add-button-container button{
        border: none;
        color: white;
        cursor: pointer;
        padding: 8px 20px;
        border-radius: 6px;
        background-color: rgba(155, 30, 30, 0.952);
        box-shadow: 2px 2px 2px rgba(0, 0, 0, 0.5);
    }
    /*Recipients tab*/
    .inactive-devices-report-recipients-controls-container{
        display: flex;
        padding: 20px 30px;
        justify-content: space-between;
    }
    .inactive-devices-report-recipients-controls-container p{
        margin: 0px;
    }
    .inactive-devices-report-recipients-controls-container button{
        border: none;
        color: white;
        cursor: pointer;
        padding: 5px 14px;
        border-radius: 4px;
        box-shadow: 2px 2px 4px rgba(0, 0, 0, 0.5);
        background-color: rgba(155, 30, 30, 0.952);
    }
    .inactive-devices-report-recipients-empty-table-container{
        width: 30vw;
        margin-top: 5vh;
        margin-left: 14vw;
        padding: 10px 20px;
        border-radius: 10px;
        box-shadow: 0px 0px 5px rgba(0, 0, 0, 0.5);
    }
    .inactive-devices-report-recipients-empty-table-container h4{
        margin: 0px;
        font-size: 18px;
        text-align: center;
        font-weight: lighter;
    }
    .inactive-devices-report-recipients-empty-table-container p{
        margin: 6px 0px;
    }
    .inactive-devices-report-recipients-table-container{
        height: 30vh;
        margin: 5px 30px;
        padding: 2px 5px;
        overflow-y: auto;
    }
    .inactive-devices-report-recipients-table-container table{
        width: 100%;
        margin: 0px;
        padding: 0px;
        font-size: 16px;
        text-align: left;
        table-layout: fixed;
        box-sizing: border-box;
        border-collapse: collapse;
        box-shadow: 0px 0px 2px rgba(0, 0, 0, 0.5);
    }
    #inactive-devices-report-recipients-table-header-row{
        background-color: transparent;
    }
    .inactive-devices-report-recipients-table-container table td,
    .inactive-devices-report-recipients-table-container table th{
        padding: 4px 6px;
    }
    .inactive-devices-report-recipients-table-container table tr:nth-child(odd){
        background-color: rgba(206, 206, 206,0.953);
    }
    .inactive-devices-report-recipients-table-container table img{
        height: 20px;
        cursor: pointer;
    }
    .inactive-devices-report-new-recipient-entry-container{
        position: absolute;
        background-color: white;
        box-shadow: 0px 0px 2px rgba(0, 0, 0, 0.5);
        height: 23vh;
        width: 26vw;
        top: 21vh;
        left: 33vh;
        border-radius: 10px;
    }
    .inactive-devices-report-new-recipient-entry-header{
        display: flex;
        color: white;
        padding: 10px 15px;
        justify-content: space-between;
        border-radius: 10px 10px 0px 0px;
        background-color: rgba(155, 30, 30, 0.952);
    }
    .inactive-devices-report-new-recipient-entry-header h3{
        margin: 0px;
    }
    .inactive-devices-report-new-recipient-entry-header p{
        margin: 0px;
        cursor: pointer;
    }
    .inactive-devices-report-new-recipient-entry-body{
        padding: 10px 15px;
    }
    .inactive-devices-report-new-recipient-name-container,
    .inactive-devices-report-new-recipient-email-address-container{
        display: grid;
        padding: 10px;
        grid-template-columns: 2fr 3fr;
    }
    .inactive-devices-report-new-recipient-name-container p,
    .inactive-devices-report-new-recipient-email-address-container p{
        margin: 0px;
    }
    .inactive-devices-report-new-recipient-name-container input,
    .inactive-devices-report-new-recipient-email-address-container input{
        border: none;
        outline: none;
        padding: 6px 10px;
        border-radius: 4px;
        box-shadow: 0px 0px 4px rgba(0, 0, 0, 0.5);
    }
    .inactive-devices-report-new-recipient-add-button-container{
        text-align: right;
        padding:15px;
    }
    .inactive-devices-report-new-recipient-add-button-container button{
        border: none;
        color: white;
        cursor: pointer;
        padding: 8px 20px;
        border-radius: 6px;
        background-color: rgba(155, 30, 30, 0.952);
        box-shadow: 2px 2px 2px rgba(0, 0, 0, 0.5);
    }
}
@media screen and (max-width:949px){
    .inactive-devices-report-container{
        box-shadow: 0 0 5px rgba(0, 0, 0, 0.5);
        background-color: white;
        position: absolute;
        top: 0vh;
        right: 0px;
        height: 100%;
        width: 100%;
        box-sizing: border-box;
        border-radius: 10px;
    }
    .inactive-devices-report-header{
        color: white;
        background-color: rgba(155, 30, 30, 0.952);
        padding: 15px;
        border-radius: 10px 10px 0px 0px;
        display: flex;
        justify-content: space-between;
    }
    .inactive-devices-report-header h3{
        margin: 0px;
        font-weight: lighter;
    }
    .inactive-devices-report-header h4{
        margin: 0px;
        font-weight: lighter;
        font-size: 14px;
    }
    .inactive-devices-report-header p{
        margin: 0px;
        cursor: pointer;
        font-size: 22px;
        margin-top: -5px;
        margin-right: 10px;
        box-sizing: border-box;
        font-weight: lighter;
    }
    .inactive-devices-report-navigation-bar{
        width: 100%;
        display: flex;
        padding: 4px 3px;
        box-sizing: border-box;
        justify-content: space-evenly;
        border-bottom: 1px solid rgb(179, 179, 179);
    }
    .inactive-devices-report-schedule-button-container,
    .inactive-devices-report-devices-button-container,
    .inactive-devices-report-recipients-button-container{
        display: inline-block;
        padding: 12px 10px;
    }
    .inactive-devices-report-tab-navigation-bar{
        width: 100%;
        display: flex;
        overflow: scroll;
    }
    .inactive-devices-report-tab-navigation-bar button{
        border: none;
        outline: none;
        margin: 0px;
        border-radius: 80px;
        padding: 8px 15px;
        cursor: pointer;
        box-shadow: 0px 0px 2px rgba(0, 0, 0, 0.5);
        background-color: transparent;
        transition: background-color 0.3s ease;
    }
    .inactive-devices-report-edit-controls{
        display: none!important;
    }
    .inactive-devices-report-edit-controls button{
        border: none;
        color: white;
        cursor: pointer;
        margin: 0px 10px;
        border-radius: 50%;
        background-color: rgba(233, 77, 30, 0.963);
    }
    .inactive-devices-report-edit-controls img{
        height: 17px;
    }
    .inactive-devices-report-save-changes-button,.inactive-devices-report-discard-changes-button{
        padding: 12px 16px;
    }
    .inactive-devices-report-edit-button{
        margin: 0px;
        padding: 10px 12px;
    }
    /*Details tab*/
    .inactive-devices-report-details-tab-container{
        display: flex;
        margin: 10px;
        padding: 8vh 30px;
        border-radius: 10px;
        align-content: center;
        justify-content: left;
        box-shadow: 0px 0px 1px rgba(0, 0, 0, 0.5);
    }
    .inactive-devices-report-details-tab-container p{
        margin: 0px;
        margin-top: 8px;
        margin-right: 40px;
    }
    .inactive-devices-report-details-tab-container input{
        width: 50%;
        margin: 0px;
        border: none;
        outline: none;
        padding: 10px 20px;
        border-radius: 20px;
        box-shadow: 0px 0px 4px rgba(0, 0, 0, 0.5);
    }
    /*Devices tab*/
    .inactive-devices-report-devices-controls-container{
        display: flex;
        padding: 20px 30px;
        justify-content: space-between;
    }
    .inactive-devices-report-devices-controls-container p{
        margin: 0px;
    }
    .inactive-devices-report-devices-controls-container button{
        border: none;
        color: white;
        cursor: pointer;
        padding: 5px 14px;
        border-radius: 4px;
        box-shadow: 2px 2px 4px rgba(0, 0, 0, 0.5);
        background-color: rgba(155, 30, 30, 0.952);
    }
    .inactive-devices-report-devices-empty-table-container{
        width: 30vw;
        margin-top: 5vh;
        margin-left: 14vw;
        padding: 10px 20px;
        border-radius: 10px;
        box-shadow: 0px 0px 5px rgba(0, 0, 0, 0.5);
    }
    .inactive-devices-report-devices-empty-table-container h4{
        margin: 0px;
        font-size: 18px;
        text-align: center;
        font-weight: lighter;
    }
    .inactive-devices-report-devices-empty-table-container p{
        margin: 6px 0px;
    }
    .inactive-devices-report-devices-table-container{
        width: 96%;
        height: auto;
        max-height: 30vh;
        padding: 5px 0px;
        margin: 0px 2%;
        overflow: auto;
        box-sizing: border-box;
        display: flex;
        box-shadow: 0px 0px 2px rgba(0, 0, 0, 0.5);
    }
    .inactive-devices-report-devices-table-container table{
        margin: 0px;
        padding: 0px;
        font-size: 16px;
        text-align: left;
        white-space: nowrap;
        table-layout: fixed;
        box-sizing: border-box;
        border-collapse: collapse;
    }
    .inactive-devices-report-devices-table-container table tr:nth-child(odd){
        background-color: rgba(206, 206, 206,0.953);
    }
    #inactive-devices-report-devices-table-header-row{
        background-color: transparent;
    }
    .inactive-devices-report-devices-table-container table td,
    .inactive-devices-report-devices-table-container table th{
        font-size: 14px;
        padding: 4px 10px;
    }
    .inactive-devices-report-devices-table-container table img{
        height: 20px;
        cursor: pointer;
    }
    .inactive-devices-report-devices-browser-container{
        position: absolute;
        background-color: white;
        box-shadow: 0px 0px 2px rgba(0, 0, 0, 0.5);
        height: 18vh;
        width: 24vw;
        top: 28vh;
        left: 36vh;
        border-radius: 10px;
    }
    .inactive-devices-report-devices-browser-header{
        display: flex;
        color: white;
        padding: 10px 15px;
        justify-content: space-between;
        border-radius: 10px 10px 0px 0px;
        background-color: rgba(155, 30, 30, 0.952);
    }
    .inactive-devices-report-devices-browser-header h3{
        margin: 0px;
    }
    .inactive-devices-report-devices-browser-header p{
        margin: 0px;
        cursor: pointer;
    }
    .inactive-devices-report-devices-browser-body{
        display: flex;
        justify-content: center;
    }
    .inactive-devices-report-devices-browser-body select{
        width: 80%;
        padding: 8px;
        background-color: transparent;
        box-shadow: 0px 0px 2px rgba(0, 0, 0, 0.5);
    }
    .inactive-devices-report-devices-browser-add-button-container{
        text-align: right;
        padding: 25px 10%;
    }
    .inactive-devices-report-devices-browser-add-button-container button{
        border: none;
        color: white;
        cursor: pointer;
        padding: 8px 20px;
        border-radius: 6px;
        background-color: rgba(155, 30, 30, 0.952);
        box-shadow: 2px 2px 2px rgba(0, 0, 0, 0.5);
    }
    /*Schedule tab*/
    .inactive-devices-report-schedule-controls-container{
        display: flex;
        padding: 20px 30px;
        justify-content: space-between;
    }
    .inactive-devices-report-schedule-controls-container p{
        margin: 0px;
    }
    .inactive-devices-report-schedule-controls-container button{
        border: none;
        color: white;
        cursor: pointer;
        padding: 5px 14px;
        border-radius: 4px;
        box-shadow: 2px 2px 4px rgba(0, 0, 0, 0.5);
        background-color: rgba(155, 30, 30, 0.952);
    }
    .inactive-devices-report-schedule-entries-empty-table-container{
        width: 30vw;
        margin-top: 5vh;
        margin-left: 14vw;
        padding: 10px 20px;
        border-radius: 10px;
        box-shadow: 0px 0px 5px rgba(0, 0, 0, 0.5);
    }
    .inactive-devices-report-schedule-entries-empty-table-container h4{
        margin: 0px;
        font-size: 18px;
        text-align: center;
        font-weight: lighter;
    }
    .inactive-devices-report-schedule-entries-empty-table-container p{
        margin: 6px 0px;
    }
    .inactive-devices-report-schedule-entries-table-container{
        height: auto;
        width: 94%;
        max-height: 30vh;
        margin: 5px 3%;
        padding: 2px 0px;
        overflow-y: auto;
        box-shadow: 0px 0px 2px rgba(0, 0, 0, 0.5);
    }
    .inactive-devices-report-schedule-entries-table-container table{
        margin: 0px;
        padding: 0px;
        font-size: 16px;
        text-align: left;
        white-space: nowrap;
        table-layout: fixed;
        box-sizing: border-box;
        border-collapse: collapse;
    }
    #inactive-devices-report-schedule-entries-table-header-row{
        background-color: transparent;
    }
    .inactive-devices-report-schedule-entries-table-container table tr:nth-child(odd){
        background-color: rgba(206, 206, 206,0.953);
    }
    .inactive-devices-report-schedule-entries-table-container table th,
    .inactive-devices-report-schedule-entries-table-container table td{
        padding: 4px 6px;
        font-size: 14px;
    }
    .inactive-devices-report-schedule-entries-table-container table th{
        font-weight: 700;
    }
    .inactive-devices-report-schedule-entries-table-container table td{
        font-weight: 500;
    }
    .inactive-devices-report-schedule-entries-table-container table img{
        height: 20px;
        cursor: pointer;
        padding: 4px 20px;
    }
    .inactive-devices-report-schedule-entries-table-container table div{
        display: flex;
        justify-content: center;
    }
    .report-schedule-entry-container{
        position: absolute;
        background-color: white;
        box-shadow: 0px 0px 2px rgba(0, 0, 0, 0.5);
        height: 32vh;
        width: 34vw;
        top: 22vh;
        left: 27vh;
        border-radius: 10px;
    }
    .report-schedule-entry-header{
        display: flex;
        color: white;
        padding: 10px 15px;
        justify-content: space-between;
        border-radius: 10px 10px 0px 0px;
        background-color: rgba(155, 30, 30, 0.952);
    }
    .report-schedule-entry-header h4{
        margin: 0px;
        font-weight: lighter;
    }
    .report-schedule-entry-header p{
        margin: 0px;
        cursor: pointer;
    }
    .report-schedule-frequency-entry-container{
        display: grid;
        padding: 20px 60px;
        padding-bottom: 10px;
        align-content: center;
        grid-template-columns: 2fr 3fr;
    }
    .report-schedule-frequency-entry-container p{
        margin: 6px 0px;
    }
    .report-schedule-frequency-entry-container select{
        width: 60%;
        margin: 0px;
        padding: 6px;
        background-color: transparent;
        box-shadow: 0px 0px 2px rgba(0, 0, 0, 0.5);
    }
    .report-schedule-time-entry-container{
        display: grid;
        padding: 10px 60px;
        align-content: center;
        grid-template-columns: 2fr 3fr;
    }
    .report-schedule-time-entry-container input{
        width: 54%;
        margin: 0px;
        height: 30px;
        border: none;
        outline: none;
        margin: 12px 0px;
        padding: 0px 10px;
        border-radius: 4px;
        background-color: transparent;
        box-shadow: 0px 0px 2px rgba(0, 0, 0, 0.5);
    }
    .report-schedule-inactivity-threshold-entry-container{
        display: grid;
        padding: 20px 60px;
        padding-bottom: 10px;
        align-content: center;
        grid-template-columns: 2fr 3fr;
    }
    .report-schedule-inactivity-threshold-entry-container p{
        margin: 6px 0px;
    }
    .report-schedule-inactivity-threshold-entry-container select{
        width: 60%;
        margin: 0px;
        padding: 6px;
        background-color: transparent;
        box-shadow: 0px 0px 2px rgba(0, 0, 0, 0.5);
    }
    .report-schedule-add-button-container{
        text-align: right;
        padding: 0px 30px;
    }
    .report-schedule-add-button-container button{
        border: none;
        color: white;
        cursor: pointer;
        padding: 8px 20px;
        border-radius: 6px;
        background-color: rgba(155, 30, 30, 0.952);
        box-shadow: 2px 2px 2px rgba(0, 0, 0, 0.5);
    }
    /*Recipients tab*/
    .inactive-devices-report-recipients-controls-container{
        display: flex;
        padding: 20px 30px;
        justify-content: space-between;
    }
    .inactive-devices-report-recipients-controls-container p{
        margin: 0px;
    }
    .inactive-devices-report-recipients-controls-container button{
        border: none;
        color: white;
        cursor: pointer;
        padding: 5px 14px;
        border-radius: 4px;
        box-shadow: 2px 2px 4px rgba(0, 0, 0, 0.5);
        background-color: rgba(155, 30, 30, 0.952);
    }
    .inactive-devices-report-recipients-empty-table-container{
        width: 30vw;
        margin-top: 5vh;
        margin-left: 14vw;
        padding: 10px 20px;
        border-radius: 10px;
        box-shadow: 0px 0px 5px rgba(0, 0, 0, 0.5);
    }
    .inactive-devices-report-recipients-empty-table-container h4{
        margin: 0px;
        font-size: 18px;
        text-align: center;
        font-weight: lighter;
    }
    .inactive-devices-report-recipients-empty-table-container p{
        margin: 6px 0px;
    }
    .inactive-devices-report-recipients-table-container{
        width: 94%;
        height: auto;
        max-height: 30vh;
        margin: 5px 3%;
        padding: 2px 0px;
        overflow-y: auto;
        box-shadow: 0px 0px 2px rgba(0, 0, 0, 0.5);
    }
    .inactive-devices-report-recipients-table-container table{
        margin: 0px;
        padding: 0px;
        font-size: 16px;
        text-align: left;
        white-space: nowrap;
        table-layout: fixed;
        box-sizing: border-box;
        border-collapse: collapse;
    }
    #inactive-devices-report-recipients-table-header-row{
        background-color: transparent;
    }
    .inactive-devices-report-recipients-table-container table td,
    .inactive-devices-report-recipients-table-container table th{
        font-size: 15px;
        padding: 4px 6px;
        padding-right: 10px;
    }
    .inactive-devices-report-recipients-table-container table tr:nth-child(odd){
        background-color: rgba(206, 206, 206,0.953);
    }
    .inactive-devices-report-recipients-table-container table img{
        height: 20px;
        cursor: pointer;
    }
    .inactive-devices-report-new-recipient-entry-container{
        position: absolute;
        background-color: white;
        box-shadow: 0px 0px 2px rgba(0, 0, 0, 0.5);
        height: 23vh;
        width: 26vw;
        top: 21vh;
        left: 33vh;
        border-radius: 10px;
    }
    .inactive-devices-report-new-recipient-entry-header{
        display: flex;
        color: white;
        padding: 10px 15px;
        justify-content: space-between;
        border-radius: 10px 10px 0px 0px;
        background-color: rgba(155, 30, 30, 0.952);
    }
    .inactive-devices-report-new-recipient-entry-header h3{
        margin: 0px;
    }
    .inactive-devices-report-new-recipient-entry-header p{
        margin: 0px;
        cursor: pointer;
    }
    .inactive-devices-report-new-recipient-entry-body{
        padding: 10px 15px;
    }
    .inactive-devices-report-new-recipient-name-container,
    .inactive-devices-report-new-recipient-email-address-container{
        display: grid;
        padding: 10px;
        grid-template-columns: 2fr 3fr;
    }
    .inactive-devices-report-new-recipient-name-container p,
    .inactive-devices-report-new-recipient-email-address-container p{
        margin: 0px;
    }
    .inactive-devices-report-new-recipient-name-container input,
    .inactive-devices-report-new-recipient-email-address-container input{
        border: none;
        outline: none;
        padding: 6px 10px;
        border-radius: 4px;
        box-shadow: 0px 0px 4px rgba(0, 0, 0, 0.5);
    }
    .inactive-devices-report-new-recipient-add-button-container{
        text-align: right;
        padding:15px;
    }
    .inactive-devices-report-new-recipient-add-button-container button{
        border: none;
        color: white;
        cursor: pointer;
        padding: 8px 20px;
        border-radius: 6px;
        background-color: rgba(155, 30, 30, 0.952);
        box-shadow: 2px 2px 2px rgba(0, 0, 0, 0.5);
    }
}
/*Message box*/
.inactive-devices-report-message-box-container{
    position: absolute;
    background-color: white;
    box-shadow: 0px 0px 2px rgba(0, 0, 0, 0.5);
    height: 16vh;
    width: 28vw;
    top: 22vh;
    left: 34vh;
    border-radius: 10px;
}
.inactive-devices-report-message-box-header{
    display: flex;
    color: white;
    padding: 10px 15px;
    justify-content: space-between;
    border-radius: 10px 10px 0px 0px;
    background-color: rgba(155, 30, 30, 0.952);
}
.inactive-devices-report-message-box-header h3{
    font-weight: lighter;
    margin: 0px;
}
.inactive-devices-report-message-box-header p{
    margin: 0px;
    cursor: pointer;
}
.inactive-devices-report-message-box-body{
    display: flex;
    justify-content: center;
}
.inactive-devices-report-message-box-buttons-container{
    text-align: right;
    padding: 0px 20px;
}
.inactive-devices-report-message-box-buttons-container button{
    border: none;
    color: white;
    cursor: pointer;
    padding: 8px 20px;
    border-radius: 6px;
    background-color: rgba(155, 30, 30, 0.952);
    box-shadow: 2px 2px 2px rgba(0, 0, 0, 0.5);
}`, "",{"version":3,"sources":["webpack://./src/styles/workspace_styles/TenantAdministratorStyles/InactiveDevicesReports/InactiveDevicesReport.css"],"names":[],"mappings":"AAAA;IACI;QACI,sCAAsC;QACtC,uBAAuB;QACvB,kBAAkB;QAClB,QAAQ;QACR,UAAU;QACV,WAAW;QACX,SAAS;QACT,sBAAsB;QACtB,gCAAgC;QAChC,+EAA+E;IACnF;IACA;QACI;YACI,QAAQ;QACZ;QACA;YACI,UAAU;QACd;IACJ;IACA;QACI,YAAY;QACZ,0CAA0C;QAC1C,aAAa;QACb,+BAA+B;QAC/B,aAAa;QACb,8BAA8B;IAClC;IACA;QACI,WAAW;QACX,oBAAoB;IACxB;IACA;QACI,WAAW;QACX,oBAAoB;QACpB,eAAe;IACnB;IACA;QACI,WAAW;QACX,kBAAkB;QAClB,oBAAoB;QACpB,eAAe;QACf,eAAe;IACnB;IACA;QACI,aAAa;QACb,gBAAgB;QAChB,8BAA8B;QAC9B,2CAA2C;IAC/C;IACA;;;QAGI,qBAAqB;QACrB,kBAAkB;IACtB;IACA;QACI,YAAY;QACZ,aAAa;QACb,WAAW;QACX,mBAAmB;QACnB,iBAAiB;QACjB,eAAe;QACf,0CAA0C;QAC1C,6BAA6B;QAC7B,sCAAsC;IAC1C;IACA;QACI,iBAAiB;QACjB,mBAAmB;IACvB;IACA;QACI,YAAY;QACZ,YAAY;QACZ,eAAe;QACf,gBAAgB;QAChB,kBAAkB;QAClB,0CAA0C;IAC9C;IACA;QACI,YAAY;IAChB;IACA;QACI,kBAAkB;IACtB;IACA;QACI,WAAW;QACX,kBAAkB;IACtB;IACA,cAAc;IACd;QACI,aAAa;QACb,YAAY;QACZ,iBAAiB;QACjB,mBAAmB;QACnB,qBAAqB;QACrB,qBAAqB;QACrB,0CAA0C;IAC9C;IACA;QACI,WAAW;QACX,eAAe;QACf,kBAAkB;IACtB;IACA;QACI,UAAU;QACV,WAAW;QACX,YAAY;QACZ,aAAa;QACb,kBAAkB;QAClB,mBAAmB;QACnB,0CAA0C;IAC9C;IACA,cAAc;IACd;QACI,aAAa;QACb,kBAAkB;QAClB,8BAA8B;IAClC;IACA;QACI,WAAW;IACf;IACA;QACI,YAAY;QACZ,YAAY;QACZ,eAAe;QACf,iBAAiB;QACjB,kBAAkB;QAClB,0CAA0C;QAC1C,0CAA0C;IAC9C;IACA;QACI,WAAW;QACX,eAAe;QACf,iBAAiB;QACjB,kBAAkB;QAClB,mBAAmB;QACnB,0CAA0C;IAC9C;IACA;QACI,WAAW;QACX,eAAe;QACf,kBAAkB;QAClB,oBAAoB;IACxB;IACA;QACI,eAAe;IACnB;IACA;QACI,YAAY;QACZ,gBAAgB;QAChB,gBAAgB;QAChB,gBAAgB;IACpB;IACA;QACI,WAAW;QACX,WAAW;QACX,YAAY;QACZ,eAAe;QACf,gBAAgB;QAChB,mBAAmB;QACnB,sBAAsB;QACtB,yBAAyB;QACzB,0CAA0C;IAC9C;IACA;QACI,2CAA2C;IAC/C;IACA;QACI,6BAA6B;IACjC;IACA;;QAEI,gBAAgB;IACpB;IACA;QACI,YAAY;QACZ,eAAe;IACnB;IACA;QACI,kBAAkB;QAClB,uBAAuB;QACvB,0CAA0C;QAC1C,YAAY;QACZ,WAAW;QACX,SAAS;QACT,UAAU;QACV,mBAAmB;IACvB;IACA;QACI,aAAa;QACb,YAAY;QACZ,kBAAkB;QAClB,8BAA8B;QAC9B,gCAAgC;QAChC,0CAA0C;IAC9C;IACA;QACI,WAAW;IACf;IACA;QACI,WAAW;QACX,eAAe;IACnB;IACA;QACI,aAAa;QACb,uBAAuB;IAC3B;IACA;QACI,UAAU;QACV,YAAY;QACZ,6BAA6B;QAC7B,0CAA0C;IAC9C;IACA;QACI,iBAAiB;QACjB,iBAAiB;IACrB;IACA;QACI,YAAY;QACZ,YAAY;QACZ,eAAe;QACf,iBAAiB;QACjB,kBAAkB;QAClB,0CAA0C;QAC1C,0CAA0C;IAC9C;IACA,eAAe;IACf;QACI,aAAa;QACb,kBAAkB;QAClB,8BAA8B;IAClC;IACA;QACI,WAAW;IACf;IACA;QACI,YAAY;QACZ,YAAY;QACZ,eAAe;QACf,iBAAiB;QACjB,kBAAkB;QAClB,0CAA0C;QAC1C,0CAA0C;IAC9C;IACA;QACI,WAAW;QACX,eAAe;QACf,iBAAiB;QACjB,kBAAkB;QAClB,mBAAmB;QACnB,0CAA0C;IAC9C;IACA;QACI,WAAW;QACX,eAAe;QACf,kBAAkB;QAClB,oBAAoB;IACxB;IACA;QACI,eAAe;IACnB;IACA;QACI,YAAY;QACZ,gBAAgB;QAChB,gBAAgB;QAChB,gBAAgB;IACpB;IACA;QACI,WAAW;QACX,WAAW;QACX,YAAY;QACZ,eAAe;QACf,gBAAgB;QAChB,mBAAmB;QACnB,sBAAsB;QACtB,yBAAyB;QACzB,0CAA0C;IAC9C;IACA;QACI,6BAA6B;IACjC;IACA;QACI,2CAA2C;IAC/C;IACA;;QAEI,gBAAgB;IACpB;IACA;QACI,gBAAgB;IACpB;IACA;QACI,gBAAgB;IACpB;IACA;QACI,YAAY;QACZ,eAAe;QACf,iBAAiB;IACrB;IACA;QACI,aAAa;QACb,uBAAuB;IAC3B;IACA;QACI,kBAAkB;QAClB,uBAAuB;QACvB,0CAA0C;QAC1C,YAAY;QACZ,WAAW;QACX,SAAS;QACT,UAAU;QACV,mBAAmB;IACvB;IACA;QACI,aAAa;QACb,YAAY;QACZ,kBAAkB;QAClB,8BAA8B;QAC9B,gCAAgC;QAChC,0CAA0C;IAC9C;IACA;QACI,WAAW;QACX,oBAAoB;IACxB;IACA;QACI,WAAW;QACX,eAAe;IACnB;IACA;QACI,aAAa;QACb,kBAAkB;QAClB,oBAAoB;QACpB,qBAAqB;QACrB,8BAA8B;IAClC;IACA;QACI,eAAe;IACnB;IACA;QACI,UAAU;QACV,WAAW;QACX,YAAY;QACZ,6BAA6B;QAC7B,0CAA0C;IAC9C;IACA;QACI,aAAa;QACb,kBAAkB;QAClB,qBAAqB;QACrB,8BAA8B;IAClC;IACA;QACI,UAAU;QACV,WAAW;QACX,YAAY;QACZ,YAAY;QACZ,aAAa;QACb,gBAAgB;QAChB,iBAAiB;QACjB,kBAAkB;QAClB,6BAA6B;QAC7B,0CAA0C;IAC9C;IACA;QACI,aAAa;QACb,kBAAkB;QAClB,oBAAoB;QACpB,qBAAqB;QACrB,8BAA8B;IAClC;IACA;QACI,eAAe;IACnB;IACA;QACI,UAAU;QACV,WAAW;QACX,YAAY;QACZ,6BAA6B;QAC7B,0CAA0C;IAC9C;IACA;QACI,iBAAiB;QACjB,iBAAiB;IACrB;IACA;QACI,YAAY;QACZ,YAAY;QACZ,eAAe;QACf,iBAAiB;QACjB,kBAAkB;QAClB,0CAA0C;QAC1C,0CAA0C;IAC9C;IACA,iBAAiB;IACjB;QACI,aAAa;QACb,kBAAkB;QAClB,8BAA8B;IAClC;IACA;QACI,WAAW;IACf;IACA;QACI,YAAY;QACZ,YAAY;QACZ,eAAe;QACf,iBAAiB;QACjB,kBAAkB;QAClB,0CAA0C;QAC1C,0CAA0C;IAC9C;IACA;QACI,WAAW;QACX,eAAe;QACf,iBAAiB;QACjB,kBAAkB;QAClB,mBAAmB;QACnB,0CAA0C;IAC9C;IACA;QACI,WAAW;QACX,eAAe;QACf,kBAAkB;QAClB,oBAAoB;IACxB;IACA;QACI,eAAe;IACnB;IACA;QACI,YAAY;QACZ,gBAAgB;QAChB,gBAAgB;QAChB,gBAAgB;IACpB;IACA;QACI,WAAW;QACX,WAAW;QACX,YAAY;QACZ,eAAe;QACf,gBAAgB;QAChB,mBAAmB;QACnB,sBAAsB;QACtB,yBAAyB;QACzB,0CAA0C;IAC9C;IACA;QACI,6BAA6B;IACjC;IACA;;QAEI,gBAAgB;IACpB;IACA;QACI,2CAA2C;IAC/C;IACA;QACI,YAAY;QACZ,eAAe;IACnB;IACA;QACI,kBAAkB;QAClB,uBAAuB;QACvB,0CAA0C;QAC1C,YAAY;QACZ,WAAW;QACX,SAAS;QACT,UAAU;QACV,mBAAmB;IACvB;IACA;QACI,aAAa;QACb,YAAY;QACZ,kBAAkB;QAClB,8BAA8B;QAC9B,gCAAgC;QAChC,0CAA0C;IAC9C;IACA;QACI,WAAW;IACf;IACA;QACI,WAAW;QACX,eAAe;IACnB;IACA;QACI,kBAAkB;IACtB;IACA;;QAEI,aAAa;QACb,aAAa;QACb,8BAA8B;IAClC;IACA;;QAEI,WAAW;IACf;IACA;;QAEI,YAAY;QACZ,aAAa;QACb,iBAAiB;QACjB,kBAAkB;QAClB,0CAA0C;IAC9C;IACA;QACI,iBAAiB;QACjB,YAAY;IAChB;IACA;QACI,YAAY;QACZ,YAAY;QACZ,eAAe;QACf,iBAAiB;QACjB,kBAAkB;QAClB,0CAA0C;QAC1C,0CAA0C;IAC9C;AACJ;AACA;IACI;QACI,sCAAsC;QACtC,uBAAuB;QACvB,kBAAkB;QAClB,QAAQ;QACR,UAAU;QACV,YAAY;QACZ,WAAW;QACX,sBAAsB;QACtB,mBAAmB;IACvB;IACA;QACI,YAAY;QACZ,0CAA0C;QAC1C,aAAa;QACb,gCAAgC;QAChC,aAAa;QACb,8BAA8B;IAClC;IACA;QACI,WAAW;QACX,oBAAoB;IACxB;IACA;QACI,WAAW;QACX,oBAAoB;QACpB,eAAe;IACnB;IACA;QACI,WAAW;QACX,eAAe;QACf,eAAe;QACf,gBAAgB;QAChB,kBAAkB;QAClB,sBAAsB;QACtB,oBAAoB;IACxB;IACA;QACI,WAAW;QACX,aAAa;QACb,gBAAgB;QAChB,sBAAsB;QACtB,6BAA6B;QAC7B,2CAA2C;IAC/C;IACA;;;QAGI,qBAAqB;QACrB,kBAAkB;IACtB;IACA;QACI,WAAW;QACX,aAAa;QACb,gBAAgB;IACpB;IACA;QACI,YAAY;QACZ,aAAa;QACb,WAAW;QACX,mBAAmB;QACnB,iBAAiB;QACjB,eAAe;QACf,0CAA0C;QAC1C,6BAA6B;QAC7B,sCAAsC;IAC1C;IACA;QACI,uBAAuB;IAC3B;IACA;QACI,YAAY;QACZ,YAAY;QACZ,eAAe;QACf,gBAAgB;QAChB,kBAAkB;QAClB,0CAA0C;IAC9C;IACA;QACI,YAAY;IAChB;IACA;QACI,kBAAkB;IACtB;IACA;QACI,WAAW;QACX,kBAAkB;IACtB;IACA,cAAc;IACd;QACI,aAAa;QACb,YAAY;QACZ,iBAAiB;QACjB,mBAAmB;QACnB,qBAAqB;QACrB,qBAAqB;QACrB,0CAA0C;IAC9C;IACA;QACI,WAAW;QACX,eAAe;QACf,kBAAkB;IACtB;IACA;QACI,UAAU;QACV,WAAW;QACX,YAAY;QACZ,aAAa;QACb,kBAAkB;QAClB,mBAAmB;QACnB,0CAA0C;IAC9C;IACA,cAAc;IACd;QACI,aAAa;QACb,kBAAkB;QAClB,8BAA8B;IAClC;IACA;QACI,WAAW;IACf;IACA;QACI,YAAY;QACZ,YAAY;QACZ,eAAe;QACf,iBAAiB;QACjB,kBAAkB;QAClB,0CAA0C;QAC1C,0CAA0C;IAC9C;IACA;QACI,WAAW;QACX,eAAe;QACf,iBAAiB;QACjB,kBAAkB;QAClB,mBAAmB;QACnB,0CAA0C;IAC9C;IACA;QACI,WAAW;QACX,eAAe;QACf,kBAAkB;QAClB,oBAAoB;IACxB;IACA;QACI,eAAe;IACnB;IACA;QACI,UAAU;QACV,YAAY;QACZ,gBAAgB;QAChB,gBAAgB;QAChB,cAAc;QACd,cAAc;QACd,sBAAsB;QACtB,aAAa;QACb,0CAA0C;IAC9C;IACA;QACI,WAAW;QACX,YAAY;QACZ,eAAe;QACf,gBAAgB;QAChB,mBAAmB;QACnB,mBAAmB;QACnB,sBAAsB;QACtB,yBAAyB;IAC7B;IACA;QACI,2CAA2C;IAC/C;IACA;QACI,6BAA6B;IACjC;IACA;;QAEI,eAAe;QACf,iBAAiB;IACrB;IACA;QACI,YAAY;QACZ,eAAe;IACnB;IACA;QACI,kBAAkB;QAClB,uBAAuB;QACvB,0CAA0C;QAC1C,YAAY;QACZ,WAAW;QACX,SAAS;QACT,UAAU;QACV,mBAAmB;IACvB;IACA;QACI,aAAa;QACb,YAAY;QACZ,kBAAkB;QAClB,8BAA8B;QAC9B,gCAAgC;QAChC,0CAA0C;IAC9C;IACA;QACI,WAAW;IACf;IACA;QACI,WAAW;QACX,eAAe;IACnB;IACA;QACI,aAAa;QACb,uBAAuB;IAC3B;IACA;QACI,UAAU;QACV,YAAY;QACZ,6BAA6B;QAC7B,0CAA0C;IAC9C;IACA;QACI,iBAAiB;QACjB,iBAAiB;IACrB;IACA;QACI,YAAY;QACZ,YAAY;QACZ,eAAe;QACf,iBAAiB;QACjB,kBAAkB;QAClB,0CAA0C;QAC1C,0CAA0C;IAC9C;IACA,eAAe;IACf;QACI,aAAa;QACb,kBAAkB;QAClB,8BAA8B;IAClC;IACA;QACI,WAAW;IACf;IACA;QACI,YAAY;QACZ,YAAY;QACZ,eAAe;QACf,iBAAiB;QACjB,kBAAkB;QAClB,0CAA0C;QAC1C,0CAA0C;IAC9C;IACA;QACI,WAAW;QACX,eAAe;QACf,iBAAiB;QACjB,kBAAkB;QAClB,mBAAmB;QACnB,0CAA0C;IAC9C;IACA;QACI,WAAW;QACX,eAAe;QACf,kBAAkB;QAClB,oBAAoB;IACxB;IACA;QACI,eAAe;IACnB;IACA;QACI,YAAY;QACZ,UAAU;QACV,gBAAgB;QAChB,cAAc;QACd,gBAAgB;QAChB,gBAAgB;QAChB,0CAA0C;IAC9C;IACA;QACI,WAAW;QACX,YAAY;QACZ,eAAe;QACf,gBAAgB;QAChB,mBAAmB;QACnB,mBAAmB;QACnB,sBAAsB;QACtB,yBAAyB;IAC7B;IACA;QACI,6BAA6B;IACjC;IACA;QACI,2CAA2C;IAC/C;IACA;;QAEI,gBAAgB;QAChB,eAAe;IACnB;IACA;QACI,gBAAgB;IACpB;IACA;QACI,gBAAgB;IACpB;IACA;QACI,YAAY;QACZ,eAAe;QACf,iBAAiB;IACrB;IACA;QACI,aAAa;QACb,uBAAuB;IAC3B;IACA;QACI,kBAAkB;QAClB,uBAAuB;QACvB,0CAA0C;QAC1C,YAAY;QACZ,WAAW;QACX,SAAS;QACT,UAAU;QACV,mBAAmB;IACvB;IACA;QACI,aAAa;QACb,YAAY;QACZ,kBAAkB;QAClB,8BAA8B;QAC9B,gCAAgC;QAChC,0CAA0C;IAC9C;IACA;QACI,WAAW;QACX,oBAAoB;IACxB;IACA;QACI,WAAW;QACX,eAAe;IACnB;IACA;QACI,aAAa;QACb,kBAAkB;QAClB,oBAAoB;QACpB,qBAAqB;QACrB,8BAA8B;IAClC;IACA;QACI,eAAe;IACnB;IACA;QACI,UAAU;QACV,WAAW;QACX,YAAY;QACZ,6BAA6B;QAC7B,0CAA0C;IAC9C;IACA;QACI,aAAa;QACb,kBAAkB;QAClB,qBAAqB;QACrB,8BAA8B;IAClC;IACA;QACI,UAAU;QACV,WAAW;QACX,YAAY;QACZ,YAAY;QACZ,aAAa;QACb,gBAAgB;QAChB,iBAAiB;QACjB,kBAAkB;QAClB,6BAA6B;QAC7B,0CAA0C;IAC9C;IACA;QACI,aAAa;QACb,kBAAkB;QAClB,oBAAoB;QACpB,qBAAqB;QACrB,8BAA8B;IAClC;IACA;QACI,eAAe;IACnB;IACA;QACI,UAAU;QACV,WAAW;QACX,YAAY;QACZ,6BAA6B;QAC7B,0CAA0C;IAC9C;IACA;QACI,iBAAiB;QACjB,iBAAiB;IACrB;IACA;QACI,YAAY;QACZ,YAAY;QACZ,eAAe;QACf,iBAAiB;QACjB,kBAAkB;QAClB,0CAA0C;QAC1C,0CAA0C;IAC9C;IACA,iBAAiB;IACjB;QACI,aAAa;QACb,kBAAkB;QAClB,8BAA8B;IAClC;IACA;QACI,WAAW;IACf;IACA;QACI,YAAY;QACZ,YAAY;QACZ,eAAe;QACf,iBAAiB;QACjB,kBAAkB;QAClB,0CAA0C;QAC1C,0CAA0C;IAC9C;IACA;QACI,WAAW;QACX,eAAe;QACf,iBAAiB;QACjB,kBAAkB;QAClB,mBAAmB;QACnB,0CAA0C;IAC9C;IACA;QACI,WAAW;QACX,eAAe;QACf,kBAAkB;QAClB,oBAAoB;IACxB;IACA;QACI,eAAe;IACnB;IACA;QACI,UAAU;QACV,YAAY;QACZ,gBAAgB;QAChB,cAAc;QACd,gBAAgB;QAChB,gBAAgB;QAChB,0CAA0C;IAC9C;IACA;QACI,WAAW;QACX,YAAY;QACZ,eAAe;QACf,gBAAgB;QAChB,mBAAmB;QACnB,mBAAmB;QACnB,sBAAsB;QACtB,yBAAyB;IAC7B;IACA;QACI,6BAA6B;IACjC;IACA;;QAEI,eAAe;QACf,gBAAgB;QAChB,mBAAmB;IACvB;IACA;QACI,2CAA2C;IAC/C;IACA;QACI,YAAY;QACZ,eAAe;IACnB;IACA;QACI,kBAAkB;QAClB,uBAAuB;QACvB,0CAA0C;QAC1C,YAAY;QACZ,WAAW;QACX,SAAS;QACT,UAAU;QACV,mBAAmB;IACvB;IACA;QACI,aAAa;QACb,YAAY;QACZ,kBAAkB;QAClB,8BAA8B;QAC9B,gCAAgC;QAChC,0CAA0C;IAC9C;IACA;QACI,WAAW;IACf;IACA;QACI,WAAW;QACX,eAAe;IACnB;IACA;QACI,kBAAkB;IACtB;IACA;;QAEI,aAAa;QACb,aAAa;QACb,8BAA8B;IAClC;IACA;;QAEI,WAAW;IACf;IACA;;QAEI,YAAY;QACZ,aAAa;QACb,iBAAiB;QACjB,kBAAkB;QAClB,0CAA0C;IAC9C;IACA;QACI,iBAAiB;QACjB,YAAY;IAChB;IACA;QACI,YAAY;QACZ,YAAY;QACZ,eAAe;QACf,iBAAiB;QACjB,kBAAkB;QAClB,0CAA0C;QAC1C,0CAA0C;IAC9C;AACJ;AACA,cAAc;AACd;IACI,kBAAkB;IAClB,uBAAuB;IACvB,0CAA0C;IAC1C,YAAY;IACZ,WAAW;IACX,SAAS;IACT,UAAU;IACV,mBAAmB;AACvB;AACA;IACI,aAAa;IACb,YAAY;IACZ,kBAAkB;IAClB,8BAA8B;IAC9B,gCAAgC;IAChC,0CAA0C;AAC9C;AACA;IACI,oBAAoB;IACpB,WAAW;AACf;AACA;IACI,WAAW;IACX,eAAe;AACnB;AACA;IACI,aAAa;IACb,uBAAuB;AAC3B;AACA;IACI,iBAAiB;IACjB,iBAAiB;AACrB;AACA;IACI,YAAY;IACZ,YAAY;IACZ,eAAe;IACf,iBAAiB;IACjB,kBAAkB;IAClB,0CAA0C;IAC1C,0CAA0C;AAC9C","sourcesContent":["@media screen and (min-width:950px){\r\n    .inactive-devices-report-container{\r\n        box-shadow: 0 0 5px rgba(0, 0, 0, 0.5);\r\n        background-color: white;\r\n        position: absolute;\r\n        top: 2vh;\r\n        right: 0px;\r\n        height: 95%;\r\n        width: 0%;\r\n        box-sizing: border-box;\r\n        border-radius: 10px 0px 0px 10px;\r\n        animation: inactive-devices-report-container-stretch-in 0.45s ease-out forwards;\r\n    }\r\n    @keyframes inactive-devices-report-container-stretch-in {\r\n        from {\r\n            width: 0;\r\n        }\r\n        to{\r\n            width: 70%;\r\n        }\r\n    }\r\n    .inactive-devices-report-header{\r\n        color: white;\r\n        background-color: rgba(155, 30, 30, 0.952);\r\n        padding: 15px;\r\n        border-radius: 10px 0px 0px 0px;\r\n        display: flex;\r\n        justify-content: space-between;\r\n    }\r\n    .inactive-devices-report-header h3{\r\n        margin: 0px;\r\n        font-weight: lighter;\r\n    }\r\n    .inactive-devices-report-header h4{\r\n        margin: 0px;\r\n        font-weight: lighter;\r\n        font-size: 14px;\r\n    }\r\n    .inactive-devices-report-header p{\r\n        margin: 0px;\r\n        margin-right: 20px;\r\n        font-weight: lighter;\r\n        font-size: 30px;\r\n        cursor: pointer;\r\n    }\r\n    .inactive-devices-report-navigation-bar{\r\n        display: flex;\r\n        padding: 4px 3px;\r\n        justify-content: space-between;\r\n        border-bottom: 1px solid rgb(179, 179, 179);\r\n    }\r\n    .inactive-devices-report-schedule-button-container,\r\n    .inactive-devices-report-devices-button-container,\r\n    .inactive-devices-report-recipients-button-container{\r\n        display: inline-block;\r\n        padding: 12px 10px;\r\n    }\r\n    .inactive-devices-report-tab-navigation-bar button{\r\n        border: none;\r\n        outline: none;\r\n        margin: 0px;\r\n        border-radius: 80px;\r\n        padding: 8px 15px;\r\n        cursor: pointer;\r\n        box-shadow: 0px 0px 2px rgba(0, 0, 0, 0.5);\r\n        background-color: transparent;\r\n        transition: background-color 0.3s ease;\r\n    }\r\n    .inactive-devices-report-edit-controls{\r\n        padding: 10px 2vw;\r\n        align-items: center;\r\n    }\r\n    .inactive-devices-report-edit-controls button{\r\n        border: none;\r\n        color: white;\r\n        cursor: pointer;\r\n        margin: 0px 10px;\r\n        border-radius: 50%;\r\n        background-color: rgba(233, 77, 30, 0.963);\r\n    }\r\n    .inactive-devices-report-edit-controls img{\r\n        height: 17px;\r\n    }\r\n    .inactive-devices-report-save-changes-button,.inactive-devices-report-discard-changes-button{\r\n        padding: 12px 16px;\r\n    }\r\n    .inactive-devices-report-edit-button{\r\n        margin: 0px;\r\n        padding: 10px 12px;\r\n    }\r\n    /*Details tab*/\r\n    .inactive-devices-report-details-tab-container{\r\n        display: flex;\r\n        margin: 10px;\r\n        padding: 8vh 30px;\r\n        border-radius: 10px;\r\n        align-content: center;\r\n        justify-content: left;\r\n        box-shadow: 0px 0px 1px rgba(0, 0, 0, 0.5);\r\n    }\r\n    .inactive-devices-report-details-tab-container p{\r\n        margin: 0px;\r\n        margin-top: 8px;\r\n        margin-right: 40px;\r\n    }\r\n    .inactive-devices-report-details-tab-container input{\r\n        width: 25%;\r\n        margin: 0px;\r\n        border: none;\r\n        outline: none;\r\n        padding: 10px 20px;\r\n        border-radius: 20px;\r\n        box-shadow: 0px 0px 4px rgba(0, 0, 0, 0.5);\r\n    }\r\n    /*Devices tab*/\r\n    .inactive-devices-report-devices-controls-container{\r\n        display: flex;\r\n        padding: 20px 30px;\r\n        justify-content: space-between;\r\n    }\r\n    .inactive-devices-report-devices-controls-container p{\r\n        margin: 0px;\r\n    }\r\n    .inactive-devices-report-devices-controls-container button{\r\n        border: none;\r\n        color: white;\r\n        cursor: pointer;\r\n        padding: 5px 14px;\r\n        border-radius: 4px;\r\n        box-shadow: 2px 2px 4px rgba(0, 0, 0, 0.5);\r\n        background-color: rgba(155, 30, 30, 0.952);\r\n    }\r\n    .inactive-devices-report-devices-empty-table-container{\r\n        width: 30vw;\r\n        margin-top: 5vh;\r\n        margin-left: 14vw;\r\n        padding: 10px 20px;\r\n        border-radius: 10px;\r\n        box-shadow: 0px 0px 5px rgba(0, 0, 0, 0.5);\r\n    }\r\n    .inactive-devices-report-devices-empty-table-container h4{\r\n        margin: 0px;\r\n        font-size: 18px;\r\n        text-align: center;\r\n        font-weight: lighter;\r\n    }\r\n    .inactive-devices-report-devices-empty-table-container p{\r\n        margin: 6px 0px;\r\n    }\r\n    .inactive-devices-report-devices-table-container{\r\n        height: 30vh;\r\n        margin: 5px 30px;\r\n        padding: 2px 5px;\r\n        overflow-y: auto;\r\n    }\r\n    .inactive-devices-report-devices-table-container table{\r\n        width: 100%;\r\n        margin: 0px;\r\n        padding: 0px;\r\n        font-size: 16px;\r\n        text-align: left;\r\n        table-layout: fixed;\r\n        box-sizing: border-box;\r\n        border-collapse: collapse;\r\n        box-shadow: 0px 0px 2px rgba(0, 0, 0, 0.5);\r\n    }\r\n    .inactive-devices-report-devices-table-container table tr:nth-child(odd){\r\n        background-color: rgba(206, 206, 206,0.953);\r\n    }\r\n    #inactive-devices-report-devices-table-header-row{\r\n        background-color: transparent;\r\n    }\r\n    .inactive-devices-report-devices-table-container table td,\r\n    .inactive-devices-report-devices-table-container table th{\r\n        padding: 4px 0px;\r\n    }\r\n    .inactive-devices-report-devices-table-container table img{\r\n        height: 20px;\r\n        cursor: pointer;\r\n    }\r\n    .inactive-devices-report-devices-browser-container{\r\n        position: absolute;\r\n        background-color: white;\r\n        box-shadow: 0px 0px 2px rgba(0, 0, 0, 0.5);\r\n        height: 18vh;\r\n        width: 24vw;\r\n        top: 28vh;\r\n        left: 36vh;\r\n        border-radius: 10px;\r\n    }\r\n    .inactive-devices-report-devices-browser-header{\r\n        display: flex;\r\n        color: white;\r\n        padding: 10px 15px;\r\n        justify-content: space-between;\r\n        border-radius: 10px 10px 0px 0px;\r\n        background-color: rgba(155, 30, 30, 0.952);\r\n    }\r\n    .inactive-devices-report-devices-browser-header h3{\r\n        margin: 0px;\r\n    }\r\n    .inactive-devices-report-devices-browser-header p{\r\n        margin: 0px;\r\n        cursor: pointer;\r\n    }\r\n    .inactive-devices-report-devices-browser-body{\r\n        display: flex;\r\n        justify-content: center;\r\n    }\r\n    .inactive-devices-report-devices-browser-body select{\r\n        width: 80%;\r\n        padding: 8px;\r\n        background-color: transparent;\r\n        box-shadow: 0px 0px 2px rgba(0, 0, 0, 0.5);\r\n    }\r\n    .inactive-devices-report-devices-browser-add-button-container{\r\n        text-align: right;\r\n        padding: 25px 10%;\r\n    }\r\n    .inactive-devices-report-devices-browser-add-button-container button{\r\n        border: none;\r\n        color: white;\r\n        cursor: pointer;\r\n        padding: 8px 20px;\r\n        border-radius: 6px;\r\n        background-color: rgba(155, 30, 30, 0.952);\r\n        box-shadow: 2px 2px 2px rgba(0, 0, 0, 0.5);\r\n    }\r\n    /*Schedule tab*/\r\n    .inactive-devices-report-schedule-controls-container{\r\n        display: flex;\r\n        padding: 20px 30px;\r\n        justify-content: space-between;\r\n    }\r\n    .inactive-devices-report-schedule-controls-container p{\r\n        margin: 0px;\r\n    }\r\n    .inactive-devices-report-schedule-controls-container button{\r\n        border: none;\r\n        color: white;\r\n        cursor: pointer;\r\n        padding: 5px 14px;\r\n        border-radius: 4px;\r\n        box-shadow: 2px 2px 4px rgba(0, 0, 0, 0.5);\r\n        background-color: rgba(155, 30, 30, 0.952);\r\n    }\r\n    .inactive-devices-report-schedule-entries-empty-table-container{\r\n        width: 30vw;\r\n        margin-top: 5vh;\r\n        margin-left: 14vw;\r\n        padding: 10px 20px;\r\n        border-radius: 10px;\r\n        box-shadow: 0px 0px 5px rgba(0, 0, 0, 0.5);\r\n    }\r\n    .inactive-devices-report-schedule-entries-empty-table-container h4{\r\n        margin: 0px;\r\n        font-size: 18px;\r\n        text-align: center;\r\n        font-weight: lighter;\r\n    }\r\n    .inactive-devices-report-schedule-entries-empty-table-container p{\r\n        margin: 6px 0px;\r\n    }\r\n    .inactive-devices-report-schedule-entries-table-container{\r\n        height: 30vh;\r\n        margin: 5px 30px;\r\n        padding: 2px 5px;\r\n        overflow-y: auto;\r\n    }\r\n    .inactive-devices-report-schedule-entries-table-container table{\r\n        width: 100%;\r\n        margin: 0px;\r\n        padding: 0px;\r\n        font-size: 16px;\r\n        text-align: left;\r\n        table-layout: fixed;\r\n        box-sizing: border-box;\r\n        border-collapse: collapse;\r\n        box-shadow: 0px 0px 2px rgba(0, 0, 0, 0.5);\r\n    }\r\n    #inactive-devices-report-schedule-entries-table-header-row{\r\n        background-color: transparent;\r\n    }\r\n    .inactive-devices-report-schedule-entries-table-container table tr:nth-child(odd){\r\n        background-color: rgba(206, 206, 206,0.953);\r\n    }\r\n    .inactive-devices-report-schedule-entries-table-container table th,\r\n    .inactive-devices-report-schedule-entries-table-container table td{\r\n        padding: 4px 6px;\r\n    }\r\n    .inactive-devices-report-schedule-entries-table-container table th{\r\n        font-weight: 700;\r\n    }\r\n    .inactive-devices-report-schedule-entries-table-container table td{\r\n        font-weight: 500;\r\n    }\r\n    .inactive-devices-report-schedule-entries-table-container table img{\r\n        height: 20px;\r\n        cursor: pointer;\r\n        padding: 4px 20px;\r\n    }\r\n    .inactive-devices-report-schedule-entries-table-container table div{\r\n        display: flex;\r\n        justify-content: center;\r\n    }\r\n    .report-schedule-entry-container{\r\n        position: absolute;\r\n        background-color: white;\r\n        box-shadow: 0px 0px 2px rgba(0, 0, 0, 0.5);\r\n        height: 32vh;\r\n        width: 34vw;\r\n        top: 22vh;\r\n        left: 27vh;\r\n        border-radius: 10px;\r\n    }\r\n    .report-schedule-entry-header{\r\n        display: flex;\r\n        color: white;\r\n        padding: 10px 15px;\r\n        justify-content: space-between;\r\n        border-radius: 10px 10px 0px 0px;\r\n        background-color: rgba(155, 30, 30, 0.952);\r\n    }\r\n    .report-schedule-entry-header h4{\r\n        margin: 0px;\r\n        font-weight: lighter;\r\n    }\r\n    .report-schedule-entry-header p{\r\n        margin: 0px;\r\n        cursor: pointer;\r\n    }\r\n    .report-schedule-frequency-entry-container{\r\n        display: grid;\r\n        padding: 20px 60px;\r\n        padding-bottom: 10px;\r\n        align-content: center;\r\n        grid-template-columns: 2fr 3fr;\r\n    }\r\n    .report-schedule-frequency-entry-container p{\r\n        margin: 6px 0px;\r\n    }\r\n    .report-schedule-frequency-entry-container select{\r\n        width: 60%;\r\n        margin: 0px;\r\n        padding: 6px;\r\n        background-color: transparent;\r\n        box-shadow: 0px 0px 2px rgba(0, 0, 0, 0.5);\r\n    }\r\n    .report-schedule-time-entry-container{\r\n        display: grid;\r\n        padding: 10px 60px;\r\n        align-content: center;\r\n        grid-template-columns: 2fr 3fr;\r\n    }\r\n    .report-schedule-time-entry-container input{\r\n        width: 54%;\r\n        margin: 0px;\r\n        height: 30px;\r\n        border: none;\r\n        outline: none;\r\n        margin: 12px 0px;\r\n        padding: 0px 10px;\r\n        border-radius: 4px;\r\n        background-color: transparent;\r\n        box-shadow: 0px 0px 2px rgba(0, 0, 0, 0.5);\r\n    }\r\n    .report-schedule-inactivity-threshold-entry-container{\r\n        display: grid;\r\n        padding: 20px 60px;\r\n        padding-bottom: 10px;\r\n        align-content: center;\r\n        grid-template-columns: 2fr 3fr;\r\n    }\r\n    .report-schedule-inactivity-threshold-entry-container p{\r\n        margin: 6px 0px;\r\n    }\r\n    .report-schedule-inactivity-threshold-entry-container select{\r\n        width: 60%;\r\n        margin: 0px;\r\n        padding: 6px;\r\n        background-color: transparent;\r\n        box-shadow: 0px 0px 2px rgba(0, 0, 0, 0.5);\r\n    }\r\n    .report-schedule-add-button-container{\r\n        text-align: right;\r\n        padding: 0px 30px;\r\n    }\r\n    .report-schedule-add-button-container button{\r\n        border: none;\r\n        color: white;\r\n        cursor: pointer;\r\n        padding: 8px 20px;\r\n        border-radius: 6px;\r\n        background-color: rgba(155, 30, 30, 0.952);\r\n        box-shadow: 2px 2px 2px rgba(0, 0, 0, 0.5);\r\n    }\r\n    /*Recipients tab*/\r\n    .inactive-devices-report-recipients-controls-container{\r\n        display: flex;\r\n        padding: 20px 30px;\r\n        justify-content: space-between;\r\n    }\r\n    .inactive-devices-report-recipients-controls-container p{\r\n        margin: 0px;\r\n    }\r\n    .inactive-devices-report-recipients-controls-container button{\r\n        border: none;\r\n        color: white;\r\n        cursor: pointer;\r\n        padding: 5px 14px;\r\n        border-radius: 4px;\r\n        box-shadow: 2px 2px 4px rgba(0, 0, 0, 0.5);\r\n        background-color: rgba(155, 30, 30, 0.952);\r\n    }\r\n    .inactive-devices-report-recipients-empty-table-container{\r\n        width: 30vw;\r\n        margin-top: 5vh;\r\n        margin-left: 14vw;\r\n        padding: 10px 20px;\r\n        border-radius: 10px;\r\n        box-shadow: 0px 0px 5px rgba(0, 0, 0, 0.5);\r\n    }\r\n    .inactive-devices-report-recipients-empty-table-container h4{\r\n        margin: 0px;\r\n        font-size: 18px;\r\n        text-align: center;\r\n        font-weight: lighter;\r\n    }\r\n    .inactive-devices-report-recipients-empty-table-container p{\r\n        margin: 6px 0px;\r\n    }\r\n    .inactive-devices-report-recipients-table-container{\r\n        height: 30vh;\r\n        margin: 5px 30px;\r\n        padding: 2px 5px;\r\n        overflow-y: auto;\r\n    }\r\n    .inactive-devices-report-recipients-table-container table{\r\n        width: 100%;\r\n        margin: 0px;\r\n        padding: 0px;\r\n        font-size: 16px;\r\n        text-align: left;\r\n        table-layout: fixed;\r\n        box-sizing: border-box;\r\n        border-collapse: collapse;\r\n        box-shadow: 0px 0px 2px rgba(0, 0, 0, 0.5);\r\n    }\r\n    #inactive-devices-report-recipients-table-header-row{\r\n        background-color: transparent;\r\n    }\r\n    .inactive-devices-report-recipients-table-container table td,\r\n    .inactive-devices-report-recipients-table-container table th{\r\n        padding: 4px 6px;\r\n    }\r\n    .inactive-devices-report-recipients-table-container table tr:nth-child(odd){\r\n        background-color: rgba(206, 206, 206,0.953);\r\n    }\r\n    .inactive-devices-report-recipients-table-container table img{\r\n        height: 20px;\r\n        cursor: pointer;\r\n    }\r\n    .inactive-devices-report-new-recipient-entry-container{\r\n        position: absolute;\r\n        background-color: white;\r\n        box-shadow: 0px 0px 2px rgba(0, 0, 0, 0.5);\r\n        height: 23vh;\r\n        width: 26vw;\r\n        top: 21vh;\r\n        left: 33vh;\r\n        border-radius: 10px;\r\n    }\r\n    .inactive-devices-report-new-recipient-entry-header{\r\n        display: flex;\r\n        color: white;\r\n        padding: 10px 15px;\r\n        justify-content: space-between;\r\n        border-radius: 10px 10px 0px 0px;\r\n        background-color: rgba(155, 30, 30, 0.952);\r\n    }\r\n    .inactive-devices-report-new-recipient-entry-header h3{\r\n        margin: 0px;\r\n    }\r\n    .inactive-devices-report-new-recipient-entry-header p{\r\n        margin: 0px;\r\n        cursor: pointer;\r\n    }\r\n    .inactive-devices-report-new-recipient-entry-body{\r\n        padding: 10px 15px;\r\n    }\r\n    .inactive-devices-report-new-recipient-name-container,\r\n    .inactive-devices-report-new-recipient-email-address-container{\r\n        display: grid;\r\n        padding: 10px;\r\n        grid-template-columns: 2fr 3fr;\r\n    }\r\n    .inactive-devices-report-new-recipient-name-container p,\r\n    .inactive-devices-report-new-recipient-email-address-container p{\r\n        margin: 0px;\r\n    }\r\n    .inactive-devices-report-new-recipient-name-container input,\r\n    .inactive-devices-report-new-recipient-email-address-container input{\r\n        border: none;\r\n        outline: none;\r\n        padding: 6px 10px;\r\n        border-radius: 4px;\r\n        box-shadow: 0px 0px 4px rgba(0, 0, 0, 0.5);\r\n    }\r\n    .inactive-devices-report-new-recipient-add-button-container{\r\n        text-align: right;\r\n        padding:15px;\r\n    }\r\n    .inactive-devices-report-new-recipient-add-button-container button{\r\n        border: none;\r\n        color: white;\r\n        cursor: pointer;\r\n        padding: 8px 20px;\r\n        border-radius: 6px;\r\n        background-color: rgba(155, 30, 30, 0.952);\r\n        box-shadow: 2px 2px 2px rgba(0, 0, 0, 0.5);\r\n    }\r\n}\r\n@media screen and (max-width:949px){\r\n    .inactive-devices-report-container{\r\n        box-shadow: 0 0 5px rgba(0, 0, 0, 0.5);\r\n        background-color: white;\r\n        position: absolute;\r\n        top: 0vh;\r\n        right: 0px;\r\n        height: 100%;\r\n        width: 100%;\r\n        box-sizing: border-box;\r\n        border-radius: 10px;\r\n    }\r\n    .inactive-devices-report-header{\r\n        color: white;\r\n        background-color: rgba(155, 30, 30, 0.952);\r\n        padding: 15px;\r\n        border-radius: 10px 10px 0px 0px;\r\n        display: flex;\r\n        justify-content: space-between;\r\n    }\r\n    .inactive-devices-report-header h3{\r\n        margin: 0px;\r\n        font-weight: lighter;\r\n    }\r\n    .inactive-devices-report-header h4{\r\n        margin: 0px;\r\n        font-weight: lighter;\r\n        font-size: 14px;\r\n    }\r\n    .inactive-devices-report-header p{\r\n        margin: 0px;\r\n        cursor: pointer;\r\n        font-size: 22px;\r\n        margin-top: -5px;\r\n        margin-right: 10px;\r\n        box-sizing: border-box;\r\n        font-weight: lighter;\r\n    }\r\n    .inactive-devices-report-navigation-bar{\r\n        width: 100%;\r\n        display: flex;\r\n        padding: 4px 3px;\r\n        box-sizing: border-box;\r\n        justify-content: space-evenly;\r\n        border-bottom: 1px solid rgb(179, 179, 179);\r\n    }\r\n    .inactive-devices-report-schedule-button-container,\r\n    .inactive-devices-report-devices-button-container,\r\n    .inactive-devices-report-recipients-button-container{\r\n        display: inline-block;\r\n        padding: 12px 10px;\r\n    }\r\n    .inactive-devices-report-tab-navigation-bar{\r\n        width: 100%;\r\n        display: flex;\r\n        overflow: scroll;\r\n    }\r\n    .inactive-devices-report-tab-navigation-bar button{\r\n        border: none;\r\n        outline: none;\r\n        margin: 0px;\r\n        border-radius: 80px;\r\n        padding: 8px 15px;\r\n        cursor: pointer;\r\n        box-shadow: 0px 0px 2px rgba(0, 0, 0, 0.5);\r\n        background-color: transparent;\r\n        transition: background-color 0.3s ease;\r\n    }\r\n    .inactive-devices-report-edit-controls{\r\n        display: none!important;\r\n    }\r\n    .inactive-devices-report-edit-controls button{\r\n        border: none;\r\n        color: white;\r\n        cursor: pointer;\r\n        margin: 0px 10px;\r\n        border-radius: 50%;\r\n        background-color: rgba(233, 77, 30, 0.963);\r\n    }\r\n    .inactive-devices-report-edit-controls img{\r\n        height: 17px;\r\n    }\r\n    .inactive-devices-report-save-changes-button,.inactive-devices-report-discard-changes-button{\r\n        padding: 12px 16px;\r\n    }\r\n    .inactive-devices-report-edit-button{\r\n        margin: 0px;\r\n        padding: 10px 12px;\r\n    }\r\n    /*Details tab*/\r\n    .inactive-devices-report-details-tab-container{\r\n        display: flex;\r\n        margin: 10px;\r\n        padding: 8vh 30px;\r\n        border-radius: 10px;\r\n        align-content: center;\r\n        justify-content: left;\r\n        box-shadow: 0px 0px 1px rgba(0, 0, 0, 0.5);\r\n    }\r\n    .inactive-devices-report-details-tab-container p{\r\n        margin: 0px;\r\n        margin-top: 8px;\r\n        margin-right: 40px;\r\n    }\r\n    .inactive-devices-report-details-tab-container input{\r\n        width: 50%;\r\n        margin: 0px;\r\n        border: none;\r\n        outline: none;\r\n        padding: 10px 20px;\r\n        border-radius: 20px;\r\n        box-shadow: 0px 0px 4px rgba(0, 0, 0, 0.5);\r\n    }\r\n    /*Devices tab*/\r\n    .inactive-devices-report-devices-controls-container{\r\n        display: flex;\r\n        padding: 20px 30px;\r\n        justify-content: space-between;\r\n    }\r\n    .inactive-devices-report-devices-controls-container p{\r\n        margin: 0px;\r\n    }\r\n    .inactive-devices-report-devices-controls-container button{\r\n        border: none;\r\n        color: white;\r\n        cursor: pointer;\r\n        padding: 5px 14px;\r\n        border-radius: 4px;\r\n        box-shadow: 2px 2px 4px rgba(0, 0, 0, 0.5);\r\n        background-color: rgba(155, 30, 30, 0.952);\r\n    }\r\n    .inactive-devices-report-devices-empty-table-container{\r\n        width: 30vw;\r\n        margin-top: 5vh;\r\n        margin-left: 14vw;\r\n        padding: 10px 20px;\r\n        border-radius: 10px;\r\n        box-shadow: 0px 0px 5px rgba(0, 0, 0, 0.5);\r\n    }\r\n    .inactive-devices-report-devices-empty-table-container h4{\r\n        margin: 0px;\r\n        font-size: 18px;\r\n        text-align: center;\r\n        font-weight: lighter;\r\n    }\r\n    .inactive-devices-report-devices-empty-table-container p{\r\n        margin: 6px 0px;\r\n    }\r\n    .inactive-devices-report-devices-table-container{\r\n        width: 96%;\r\n        height: auto;\r\n        max-height: 30vh;\r\n        padding: 5px 0px;\r\n        margin: 0px 2%;\r\n        overflow: auto;\r\n        box-sizing: border-box;\r\n        display: flex;\r\n        box-shadow: 0px 0px 2px rgba(0, 0, 0, 0.5);\r\n    }\r\n    .inactive-devices-report-devices-table-container table{\r\n        margin: 0px;\r\n        padding: 0px;\r\n        font-size: 16px;\r\n        text-align: left;\r\n        white-space: nowrap;\r\n        table-layout: fixed;\r\n        box-sizing: border-box;\r\n        border-collapse: collapse;\r\n    }\r\n    .inactive-devices-report-devices-table-container table tr:nth-child(odd){\r\n        background-color: rgba(206, 206, 206,0.953);\r\n    }\r\n    #inactive-devices-report-devices-table-header-row{\r\n        background-color: transparent;\r\n    }\r\n    .inactive-devices-report-devices-table-container table td,\r\n    .inactive-devices-report-devices-table-container table th{\r\n        font-size: 14px;\r\n        padding: 4px 10px;\r\n    }\r\n    .inactive-devices-report-devices-table-container table img{\r\n        height: 20px;\r\n        cursor: pointer;\r\n    }\r\n    .inactive-devices-report-devices-browser-container{\r\n        position: absolute;\r\n        background-color: white;\r\n        box-shadow: 0px 0px 2px rgba(0, 0, 0, 0.5);\r\n        height: 18vh;\r\n        width: 24vw;\r\n        top: 28vh;\r\n        left: 36vh;\r\n        border-radius: 10px;\r\n    }\r\n    .inactive-devices-report-devices-browser-header{\r\n        display: flex;\r\n        color: white;\r\n        padding: 10px 15px;\r\n        justify-content: space-between;\r\n        border-radius: 10px 10px 0px 0px;\r\n        background-color: rgba(155, 30, 30, 0.952);\r\n    }\r\n    .inactive-devices-report-devices-browser-header h3{\r\n        margin: 0px;\r\n    }\r\n    .inactive-devices-report-devices-browser-header p{\r\n        margin: 0px;\r\n        cursor: pointer;\r\n    }\r\n    .inactive-devices-report-devices-browser-body{\r\n        display: flex;\r\n        justify-content: center;\r\n    }\r\n    .inactive-devices-report-devices-browser-body select{\r\n        width: 80%;\r\n        padding: 8px;\r\n        background-color: transparent;\r\n        box-shadow: 0px 0px 2px rgba(0, 0, 0, 0.5);\r\n    }\r\n    .inactive-devices-report-devices-browser-add-button-container{\r\n        text-align: right;\r\n        padding: 25px 10%;\r\n    }\r\n    .inactive-devices-report-devices-browser-add-button-container button{\r\n        border: none;\r\n        color: white;\r\n        cursor: pointer;\r\n        padding: 8px 20px;\r\n        border-radius: 6px;\r\n        background-color: rgba(155, 30, 30, 0.952);\r\n        box-shadow: 2px 2px 2px rgba(0, 0, 0, 0.5);\r\n    }\r\n    /*Schedule tab*/\r\n    .inactive-devices-report-schedule-controls-container{\r\n        display: flex;\r\n        padding: 20px 30px;\r\n        justify-content: space-between;\r\n    }\r\n    .inactive-devices-report-schedule-controls-container p{\r\n        margin: 0px;\r\n    }\r\n    .inactive-devices-report-schedule-controls-container button{\r\n        border: none;\r\n        color: white;\r\n        cursor: pointer;\r\n        padding: 5px 14px;\r\n        border-radius: 4px;\r\n        box-shadow: 2px 2px 4px rgba(0, 0, 0, 0.5);\r\n        background-color: rgba(155, 30, 30, 0.952);\r\n    }\r\n    .inactive-devices-report-schedule-entries-empty-table-container{\r\n        width: 30vw;\r\n        margin-top: 5vh;\r\n        margin-left: 14vw;\r\n        padding: 10px 20px;\r\n        border-radius: 10px;\r\n        box-shadow: 0px 0px 5px rgba(0, 0, 0, 0.5);\r\n    }\r\n    .inactive-devices-report-schedule-entries-empty-table-container h4{\r\n        margin: 0px;\r\n        font-size: 18px;\r\n        text-align: center;\r\n        font-weight: lighter;\r\n    }\r\n    .inactive-devices-report-schedule-entries-empty-table-container p{\r\n        margin: 6px 0px;\r\n    }\r\n    .inactive-devices-report-schedule-entries-table-container{\r\n        height: auto;\r\n        width: 94%;\r\n        max-height: 30vh;\r\n        margin: 5px 3%;\r\n        padding: 2px 0px;\r\n        overflow-y: auto;\r\n        box-shadow: 0px 0px 2px rgba(0, 0, 0, 0.5);\r\n    }\r\n    .inactive-devices-report-schedule-entries-table-container table{\r\n        margin: 0px;\r\n        padding: 0px;\r\n        font-size: 16px;\r\n        text-align: left;\r\n        white-space: nowrap;\r\n        table-layout: fixed;\r\n        box-sizing: border-box;\r\n        border-collapse: collapse;\r\n    }\r\n    #inactive-devices-report-schedule-entries-table-header-row{\r\n        background-color: transparent;\r\n    }\r\n    .inactive-devices-report-schedule-entries-table-container table tr:nth-child(odd){\r\n        background-color: rgba(206, 206, 206,0.953);\r\n    }\r\n    .inactive-devices-report-schedule-entries-table-container table th,\r\n    .inactive-devices-report-schedule-entries-table-container table td{\r\n        padding: 4px 6px;\r\n        font-size: 14px;\r\n    }\r\n    .inactive-devices-report-schedule-entries-table-container table th{\r\n        font-weight: 700;\r\n    }\r\n    .inactive-devices-report-schedule-entries-table-container table td{\r\n        font-weight: 500;\r\n    }\r\n    .inactive-devices-report-schedule-entries-table-container table img{\r\n        height: 20px;\r\n        cursor: pointer;\r\n        padding: 4px 20px;\r\n    }\r\n    .inactive-devices-report-schedule-entries-table-container table div{\r\n        display: flex;\r\n        justify-content: center;\r\n    }\r\n    .report-schedule-entry-container{\r\n        position: absolute;\r\n        background-color: white;\r\n        box-shadow: 0px 0px 2px rgba(0, 0, 0, 0.5);\r\n        height: 32vh;\r\n        width: 34vw;\r\n        top: 22vh;\r\n        left: 27vh;\r\n        border-radius: 10px;\r\n    }\r\n    .report-schedule-entry-header{\r\n        display: flex;\r\n        color: white;\r\n        padding: 10px 15px;\r\n        justify-content: space-between;\r\n        border-radius: 10px 10px 0px 0px;\r\n        background-color: rgba(155, 30, 30, 0.952);\r\n    }\r\n    .report-schedule-entry-header h4{\r\n        margin: 0px;\r\n        font-weight: lighter;\r\n    }\r\n    .report-schedule-entry-header p{\r\n        margin: 0px;\r\n        cursor: pointer;\r\n    }\r\n    .report-schedule-frequency-entry-container{\r\n        display: grid;\r\n        padding: 20px 60px;\r\n        padding-bottom: 10px;\r\n        align-content: center;\r\n        grid-template-columns: 2fr 3fr;\r\n    }\r\n    .report-schedule-frequency-entry-container p{\r\n        margin: 6px 0px;\r\n    }\r\n    .report-schedule-frequency-entry-container select{\r\n        width: 60%;\r\n        margin: 0px;\r\n        padding: 6px;\r\n        background-color: transparent;\r\n        box-shadow: 0px 0px 2px rgba(0, 0, 0, 0.5);\r\n    }\r\n    .report-schedule-time-entry-container{\r\n        display: grid;\r\n        padding: 10px 60px;\r\n        align-content: center;\r\n        grid-template-columns: 2fr 3fr;\r\n    }\r\n    .report-schedule-time-entry-container input{\r\n        width: 54%;\r\n        margin: 0px;\r\n        height: 30px;\r\n        border: none;\r\n        outline: none;\r\n        margin: 12px 0px;\r\n        padding: 0px 10px;\r\n        border-radius: 4px;\r\n        background-color: transparent;\r\n        box-shadow: 0px 0px 2px rgba(0, 0, 0, 0.5);\r\n    }\r\n    .report-schedule-inactivity-threshold-entry-container{\r\n        display: grid;\r\n        padding: 20px 60px;\r\n        padding-bottom: 10px;\r\n        align-content: center;\r\n        grid-template-columns: 2fr 3fr;\r\n    }\r\n    .report-schedule-inactivity-threshold-entry-container p{\r\n        margin: 6px 0px;\r\n    }\r\n    .report-schedule-inactivity-threshold-entry-container select{\r\n        width: 60%;\r\n        margin: 0px;\r\n        padding: 6px;\r\n        background-color: transparent;\r\n        box-shadow: 0px 0px 2px rgba(0, 0, 0, 0.5);\r\n    }\r\n    .report-schedule-add-button-container{\r\n        text-align: right;\r\n        padding: 0px 30px;\r\n    }\r\n    .report-schedule-add-button-container button{\r\n        border: none;\r\n        color: white;\r\n        cursor: pointer;\r\n        padding: 8px 20px;\r\n        border-radius: 6px;\r\n        background-color: rgba(155, 30, 30, 0.952);\r\n        box-shadow: 2px 2px 2px rgba(0, 0, 0, 0.5);\r\n    }\r\n    /*Recipients tab*/\r\n    .inactive-devices-report-recipients-controls-container{\r\n        display: flex;\r\n        padding: 20px 30px;\r\n        justify-content: space-between;\r\n    }\r\n    .inactive-devices-report-recipients-controls-container p{\r\n        margin: 0px;\r\n    }\r\n    .inactive-devices-report-recipients-controls-container button{\r\n        border: none;\r\n        color: white;\r\n        cursor: pointer;\r\n        padding: 5px 14px;\r\n        border-radius: 4px;\r\n        box-shadow: 2px 2px 4px rgba(0, 0, 0, 0.5);\r\n        background-color: rgba(155, 30, 30, 0.952);\r\n    }\r\n    .inactive-devices-report-recipients-empty-table-container{\r\n        width: 30vw;\r\n        margin-top: 5vh;\r\n        margin-left: 14vw;\r\n        padding: 10px 20px;\r\n        border-radius: 10px;\r\n        box-shadow: 0px 0px 5px rgba(0, 0, 0, 0.5);\r\n    }\r\n    .inactive-devices-report-recipients-empty-table-container h4{\r\n        margin: 0px;\r\n        font-size: 18px;\r\n        text-align: center;\r\n        font-weight: lighter;\r\n    }\r\n    .inactive-devices-report-recipients-empty-table-container p{\r\n        margin: 6px 0px;\r\n    }\r\n    .inactive-devices-report-recipients-table-container{\r\n        width: 94%;\r\n        height: auto;\r\n        max-height: 30vh;\r\n        margin: 5px 3%;\r\n        padding: 2px 0px;\r\n        overflow-y: auto;\r\n        box-shadow: 0px 0px 2px rgba(0, 0, 0, 0.5);\r\n    }\r\n    .inactive-devices-report-recipients-table-container table{\r\n        margin: 0px;\r\n        padding: 0px;\r\n        font-size: 16px;\r\n        text-align: left;\r\n        white-space: nowrap;\r\n        table-layout: fixed;\r\n        box-sizing: border-box;\r\n        border-collapse: collapse;\r\n    }\r\n    #inactive-devices-report-recipients-table-header-row{\r\n        background-color: transparent;\r\n    }\r\n    .inactive-devices-report-recipients-table-container table td,\r\n    .inactive-devices-report-recipients-table-container table th{\r\n        font-size: 15px;\r\n        padding: 4px 6px;\r\n        padding-right: 10px;\r\n    }\r\n    .inactive-devices-report-recipients-table-container table tr:nth-child(odd){\r\n        background-color: rgba(206, 206, 206,0.953);\r\n    }\r\n    .inactive-devices-report-recipients-table-container table img{\r\n        height: 20px;\r\n        cursor: pointer;\r\n    }\r\n    .inactive-devices-report-new-recipient-entry-container{\r\n        position: absolute;\r\n        background-color: white;\r\n        box-shadow: 0px 0px 2px rgba(0, 0, 0, 0.5);\r\n        height: 23vh;\r\n        width: 26vw;\r\n        top: 21vh;\r\n        left: 33vh;\r\n        border-radius: 10px;\r\n    }\r\n    .inactive-devices-report-new-recipient-entry-header{\r\n        display: flex;\r\n        color: white;\r\n        padding: 10px 15px;\r\n        justify-content: space-between;\r\n        border-radius: 10px 10px 0px 0px;\r\n        background-color: rgba(155, 30, 30, 0.952);\r\n    }\r\n    .inactive-devices-report-new-recipient-entry-header h3{\r\n        margin: 0px;\r\n    }\r\n    .inactive-devices-report-new-recipient-entry-header p{\r\n        margin: 0px;\r\n        cursor: pointer;\r\n    }\r\n    .inactive-devices-report-new-recipient-entry-body{\r\n        padding: 10px 15px;\r\n    }\r\n    .inactive-devices-report-new-recipient-name-container,\r\n    .inactive-devices-report-new-recipient-email-address-container{\r\n        display: grid;\r\n        padding: 10px;\r\n        grid-template-columns: 2fr 3fr;\r\n    }\r\n    .inactive-devices-report-new-recipient-name-container p,\r\n    .inactive-devices-report-new-recipient-email-address-container p{\r\n        margin: 0px;\r\n    }\r\n    .inactive-devices-report-new-recipient-name-container input,\r\n    .inactive-devices-report-new-recipient-email-address-container input{\r\n        border: none;\r\n        outline: none;\r\n        padding: 6px 10px;\r\n        border-radius: 4px;\r\n        box-shadow: 0px 0px 4px rgba(0, 0, 0, 0.5);\r\n    }\r\n    .inactive-devices-report-new-recipient-add-button-container{\r\n        text-align: right;\r\n        padding:15px;\r\n    }\r\n    .inactive-devices-report-new-recipient-add-button-container button{\r\n        border: none;\r\n        color: white;\r\n        cursor: pointer;\r\n        padding: 8px 20px;\r\n        border-radius: 6px;\r\n        background-color: rgba(155, 30, 30, 0.952);\r\n        box-shadow: 2px 2px 2px rgba(0, 0, 0, 0.5);\r\n    }\r\n}\r\n/*Message box*/\r\n.inactive-devices-report-message-box-container{\r\n    position: absolute;\r\n    background-color: white;\r\n    box-shadow: 0px 0px 2px rgba(0, 0, 0, 0.5);\r\n    height: 16vh;\r\n    width: 28vw;\r\n    top: 22vh;\r\n    left: 34vh;\r\n    border-radius: 10px;\r\n}\r\n.inactive-devices-report-message-box-header{\r\n    display: flex;\r\n    color: white;\r\n    padding: 10px 15px;\r\n    justify-content: space-between;\r\n    border-radius: 10px 10px 0px 0px;\r\n    background-color: rgba(155, 30, 30, 0.952);\r\n}\r\n.inactive-devices-report-message-box-header h3{\r\n    font-weight: lighter;\r\n    margin: 0px;\r\n}\r\n.inactive-devices-report-message-box-header p{\r\n    margin: 0px;\r\n    cursor: pointer;\r\n}\r\n.inactive-devices-report-message-box-body{\r\n    display: flex;\r\n    justify-content: center;\r\n}\r\n.inactive-devices-report-message-box-buttons-container{\r\n    text-align: right;\r\n    padding: 0px 20px;\r\n}\r\n.inactive-devices-report-message-box-buttons-container button{\r\n    border: none;\r\n    color: white;\r\n    cursor: pointer;\r\n    padding: 8px 20px;\r\n    border-radius: 6px;\r\n    background-color: rgba(155, 30, 30, 0.952);\r\n    box-shadow: 2px 2px 2px rgba(0, 0, 0, 0.5);\r\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
